<template>
  <section class="m-hero">
    <template v-if="banners.length == 0">
      <div class="cx-slider">
        <div class="cx-slider__slide" >
          <div class="cx-media--cover">
            <div class="cx-media__video m-hero__slide m-hero__video"
              :style="sliderStyleForRender"
              :class="sliderClassForRender"
            >
            </div>
          </div>
        </div>
      </div>
    </template>
    <cx-slider 
      v-show="banners.length > 0"
      pause-control
      volume-control
      :sliderStyle="sliderStyleForRender"
      :sliderClass="sliderClassForRender"
      :gallery="bannersForSlider" ref="slider" loop
    ></cx-slider>
    <template v-if="banner && banner.title">
      <div class="m-hero__caption">
        <div class="cx-wrap--page m-wrap--page">
          <component :is="''" v-bind="linkProps(banner.link ? banner.link : null)">
            <h2 class="cx-t30 -boxed m-hero__caption-text" style="user-select: none; z-index: 3;">
              <span v-html="banner.title"></span>
            </h2>
          </component>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'home-hero',
  lazyData({store, i18n}) {
    store.dispatch('banner/FETCH_HOME', { locale: i18n.locale });
  },
  data() {
    return {
      resizeTimer: null,
      mount: false,
      sliderStyle: {
        "padding-top": "100vh !important"
      },
      sliderClass: []
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.ui.isMobile,
      blackAndWhite: state => state.ui.blackAndWhite,
    }),
    sliderClassForRender: function() {
      return this.isMobile ? [] : this.sliderClass
    },
    sliderStyleForRender: function() {
      return this.isMobile ? {} : this.sliderStyle
    },
    banners: function() {
      return this.$store.getters['banner/getHome'](this.$i18n.locale).map(b => ({
        ...b,
        video: b.video ? this.getMediaHost(b.video, 'MGTOCMS') : '',
        path: this.getMediaHost(b.image || b.backupImage, 'MGTO_MEDIA')
      }));
    },
    banner: function() {
      if (!this.mount) return {};

      let activeIdx = this.$refs.slider ? this.$refs.slider.activeSlide - 1 : -2;

      if (activeIdx == -1) {
        activeIdx = this.banners.length - 1;
      } else if (activeIdx == this.banners.length) {
        activeIdx = 0;
      }
      
      if (activeIdx > -1 && this.banners[activeIdx]) {
        return this.banners[activeIdx];
      }

      return {};
    },
    bannersForSlider: function() {
      return this.banners.map(b => ({
        ...b,
        link: undefined
      }))
    },
  },
  methods: {
    handleResize: function() {
      this.resizeTimer != null && clearInterval(this.resizeTimer);
      this.resizeTimer = setTimeout(this.resized, 100);
    },
    resized: function() {
      // GET HEADER Height
      const mainDom = document.getElementById('main');
      if (mainDom && mainDom.offsetTop) {
        const offset = mainDom.offsetTop - 1;
        this.sliderStyle = {
          'padding-top': `calc(100vh - ${offset}px) !important`
        }
        const videoH = window.innerHeight - offset + 1;
        const videoW = window.innerWidth;
        console.log('[HH] RESIZED TO', videoW, videoH, videoH / videoW);
        this.sliderClass = videoH / videoW < .5625
          ? ['--over-width']
          : ['--over-height'];
      }
      this.resizeTimer = null;
    }
  },
  mounted() {
    this.mount = true;
    window.addEventListener('resize', this.handleResize);
    this.resized();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
}
</script>

<style lang="scss">
  .home{
    .cx-t10{
      @extend %style-subtitle;
    }
    .cx-wrap--page{
      @media (max-width:$breakpoint-lg){
        max-width: 800px;
      }
    }
  }
  .m-hero{
    background-color: $color-grey;
    a{
      &:hover{
        text-decoration: none;
        .cx-t30{
          background-color: darken($color-primary, 10%);
        }
      }
    }
    &__caption{
      @include set-font(.9);
      margin-top: -2.4em;
      position: relative;
      padding: 0 $space-base;
      br{
        display: none;
      }
      @media(min-width: $breakpoint-sm){
        @include set-font(1);
        padding: 0 $space-lg;
      }
      @media(min-width: $breakpoint-lg){
        padding: 0 $space-xl;
        @include set-font(1.05);
        br{
          display: inline;
        }
      }
    }
    &__icon{
      i{
        text-shadow: 0 0 5px rgba($color-black, .8);
      }
    }
    &__caption-text{
      @extend %transition--bgcolor;
      position: relative;
    }
    &__icon{
      // font-size: 2rem;
    }
    &__video{
      position: relative;
      video{
        position: absolute !important;
        top: 50% !important;
        left: 50% !important;
        -webkit-transform: translate(-50%, -50%) !important;
        transform: translate(-50%, -50%) !important;
        // min-width: 100% !important;
        // min-height: 100% !important;
      }
    }
    .--over-width {
      video {
        height: auto;
        width: 100% !important;
      }
    }
    .--over-height {
      video {
        width: auto;
        height: 100% !important;
      }
    }
  }

  .m-hero{
    .m-hero__slide{
      overflow: hidden;
      padding-top: 38% !important;
      @media(max-width:767px){
      padding-top: 56.25% !important;
      }
    }
  }
</style>
